// The code in this file will load on every page of your site

$w.onReady(function () {
	// Write your code here
});

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function vectorImage2_click(event) {$w("#vectorImage2").onClick((event) => {$w("#searchBox2").show("fade","2")});
{$w("#searchBox2").hide("fade","200")}
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}
import wixWindow from 'wix-window';
$w.onReady(function () {
  let myLang = wixWindow.multilingual.currentLanguage; 
  if (myLang === 'he') {
    $w('#LTREnglishMenu').hide();
    $w('#RTLHebrewMenu').show();
  } else {
    $w('#RTLHebrewMenu').hide();
    $w('#LTREnglishMenu').show();  
	};
});